import { render, staticRenderFns } from "./Gestor.vue?vue&type=template&id=d6c53ff4"
import script from "./Gestor.vue?vue&type=script&lang=js"
export * from "./Gestor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports